const buttons = document.querySelectorAll(".threedium-init");

buttons.forEach(button => {
    button.addEventListener("click", () => {
        const popupId = button.getAttribute("data-popup");
        const popup = document.querySelector(`.threedium-popup[data-popup="${popupId}"]`);

        if (popup) {
            popup.classList.add("active");

            const iframe = popup.querySelector(".threedium-iframe");
            if (iframe) {
                iframe.src = iframe.src;
            }
            document.body.style.overflow = "hidden";
        }
    });
});


const closeButtons = document.querySelectorAll(".threedium-popup-close");
closeButtons.forEach(button => {
    button.addEventListener("click", () => {
        const popup = button.closest(".threedium-popup");
        if(popup){
            popup.classList.remove("active");
            document.body.style.overflow = '';
        }
    });
});

/* ESC key closes all active popups */
document.addEventListener("keydown", (e) => {
    if(e.key === "Escape"){
        document.querySelectorAll(".threedium-popup.active").forEach(popup => {
            popup.classList.remove("active");
        });
        document.body.style.overflow = '';
    }
});
